import createVueApp from '@phoenix/createVueApp';
import LightContactCheckout from '@maison/components/light-checkout/LightContactCheckout.vue';

const app = createVueApp({}, true);
app.component('LightContactCheckout', LightContactCheckout);
app.mount('#phoenix-light-contact-checkout');
